import * as Yup from "yup";
import { Request } from "../../hooks/Request";
import logotipo from "../../assets/LogotipoTC.png";
import { Circle } from "../../components/Animation";
import { toast } from "react-toastify";
import { requestAuth } from "../../components/services/RequestService";
import View from "../../components/GeneratePdf/View";
import Text from "../../components/GeneratePdf/Text";
import { useAuth } from "../../contexts/AuthContext";
import { useDialog } from "../../contexts/DialogContext";
import { Button } from "../../components/Buttons";
import FormDefault from "../../components/Forms/FormDefault";
import { Page, Document, PDFViewer, Image, pdf } from "@react-pdf/renderer";
import * as dayjs from "dayjs";
dayjs.locale("es");

const RenderSettlement = (props) => {
  const { openDialog } = useDialog();

  const { data, loading } = Request({
    urlApi: "/dropdown/user/accountNumbers",
  });

  function handleProform(values) {
    openDialog(
      <LiquidaciónProform {...props} accountNumber={values.account} />
    );
  }

  function handleAccount() {
    const list = data.map((item) =>
      item.accountNumber
        ? {
          label: `${item.accountNumber} - ${item.name} ${item.fatherLastName}`,
          value: item.accountNumber,
        }
        : null
    );
    return list.filter((n) => n);
  }

  if (!loading) {
    return <Circle />;
  }
  return (
    <FormDefault
      tittle="Elaborador por/ Nro de Cuenta Bancaria a Depositar"
      fields={[
        {
          label: "Atención",
          name: "account",
          typeInput: "select",
          options: handleAccount(),
          //   [
          //   {
          //     label: "Original",
          //     value: "Original",
          //   },
          //   {
          //     label: "Copia",
          //     value: "Copia",
          //   },
          //   {
          //     label: "Fotocopia simple",
          //     value: "Fotocopia simple",
          //   },
          //   {
          //     label: "Fotocopia legalizada",
          //     value: "Fotocopia legalizada",
          //   },
          // ],
          // typeInput: "selectNewOption",
          // urlApi: "/dropdown/user/accountNumbers",
          // value: "name",
          // labelOption: "name",
        },
      ]}
      initialValues={{
        account: "",
      }}
      validationSchema={Yup.object().shape({
        // atn: Yup.string().required("Campo requerido"),
      })}
      onSubmit={handleProform}
      buttonName="Registrar"
    />
  );
};

const LiquidaciónProform = (props) => {
  const { procedure, accountNumber, isQuotation } = props;
  const { user } = useAuth();
  const fieldnames = [
    "codigoDeInterno",
    "descripciónDeLaMercancía",
    "medioDeTransporte",
    "nro_DeFactura",
    "proveedor",
    "f3TotalNúmeroDeBultos",
    "f4TotalPesoBruto",
    "contacto",
    "serviciosAduaneros", // subdatas de servicio aduaneros
    "f6TotalValorFob",
    "fleteIYIi",
    "f8TotalCostoDelSeguro",
    "f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos",
    "tributosUOtrasGastosPagadosPorElImportador",
    "totalAnticipos",
    "a3NúmeroDeReferencia",
    "documentosSeccionL", //subdatas de la section L
    "cifUsd",
    "a4AduanaDeDespacho",
    "a6ModalidadDelRégimen",
    "f2TotalNúmeroDeItems",
    "a1NúmeroDeDeclaración",
    "a2FechaDeAceptación",
    "TipoDeCambio",
    "f10TotalValorCifAduana",
    "gastosPuerto",
    "otrosErogaciones",
    "nroDeInterno",
  ];
  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.id || procedure.procedureId}/dataValues?${fieldnames.map(f => `fieldnames=${encodeURIComponent(f)}`).join("&")}`,
  });
  if (!loading) {
    return <div className="p-2"><Circle /></div>;
  }

  async function handleOnClick() {
    const fileName = `Planilla-${dayjs().format("DD-MM-YYYY")}.pdf`;
    const blob = await pdf(MyDoc).toBlob();
    const file = new File([blob], fileName, { type: "application/pdf" });

    await uploadFile(file);
  }

  async function uploadFile(file) {
    let formData = new FormData();
    formData.append("Name", `Planilla-${dayjs().format("DD-MM-YYYY")}`);
    formData.append("File", file);
    formData.append(
      "originalName",
      `Planilla-${dayjs().format("DD-MM-YYYY")}.pdf`
    );
    formData.append("Status", "verified");
    formData.append("ProcedureId", procedure.id || procedure.procedureId);
    await requestAuth("post", "/files", formData)
      .then((res) => {
        handleRegister({
          url: res.data.url,
          name: `Planilla-${dayjs().format("DD-MM-YYYY")}`,
        });
      })
      .catch(() => {
        toast.error("Se produjo un error al subir el archivo");
      });
  }

  async function handleRegister(values) {
    await requestAuth(
      "post",
      `/fileState/procedure/${procedure.id || procedure.procedureId}/field/725`,
      values
    )
      .then(() => {
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  const MyDoc = (
    <Document>
      <Page size="A4" style={{ padding: "20px" }}>
        <Image
          src={
            // 'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763749558/TRAZO/LOGOS/Imagen1_dwsaix.png'
            user?.institutionParam?.find(d => d.code === 'logo')?.value ?? ""
          } // o la URL del logo
          style={{
            position: "absolute",
            top: "25%",
            left: "25%",
            width: "400px", // ajusta tamaño
            height: "400px",
            opacity: 0.1, // opacidad baja para que sea marca de agua
            transform: "translate(-50%, -50%)", // centra la imagen
            zIndex: 0,
          }}
        />
        <View flexDirection="column" borderContent>
          <View padding="4px" style={{ backgroundColor: "#213a8f" }}></View>
          <View flexDirection="column">
            <View
              justifyContent="space-between"
              alignItems="center"
              padding="4px 4px"
            >
              <View width="25%">
                <Image src={
                  // 'https://res.cloudinary.com/dnwvlkw3r/image/upload/v1763749558/TRAZO/LOGOS/Imagen1_dwsaix.png'
                  user?.institutionParam?.find(d => d.code === 'logo')?.value ?? ""
                } style={{ height: "50px" }} />
              </View>
              <View
                width="60%"
                flexDirection="column"
                alignItems="flex-end"
                justifyContent="flex-end"
              >
                <Text
                  color="#213a8f"
                  padding="0px 3px"
                  textAlign="end"
                  fontSize="16px"
                  bold
                >
                  {isQuotation ? 'COTIZACIÓN' : 'PLANILLA DE COBRANZA'}
                  {/* PROFORMA */}
                </Text>
                <Text
                  color="#213a8f"
                  padding="0px 3px"
                  fontSize="18px"
                  bold
                  textAlign="end"
                >
                  {isQuotation ? data.nroQuotation : data.codigoDeInterno}
                </Text>
                <Text fontSize="10px" padding="0px 3px" textAlign="end">
                  La Paz {dayjs().format("DD")} de {dayjs().format("MMMM")}{" "}
                  del {dayjs().format("YYYY")}
                </Text>
              </View>
            </View>
            <View
              border={{ top: true }}
              // style={{ marginTop: "5px" }}
              padding="3px 0px 0px 0px"
            >
              <View width="65%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    SEÑOR(ES):{" "}
                  </Text>
                  <Text padding="2px 3px">{data.company.razonSocial}</Text>
                </Text>
              </View>
              <View width="35%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    NIT:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.company.nit}</Text>
                </Text>
              </View>
            </View>
            <View
            // style={{ marginTop: "5px" }}
            >
              <View width="65%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Doc. Embarque:{" "}
                  </Text>
                  <Text padding="2px 3px">
                    {data.documentosSeccionLSubDatas
                      ?.find((doc) => {
                        const lbl = doc.label?.toUpperCase() || "";
                        return ["CRT", "BILL OF LADING", "CONOCIMIENTO DE EMBARQUE", "GUÍA COURIER", "GUIA COURIER"].some(kw => lbl.includes(kw));
                      })
                      ?.description2}
                  </Text>
                </Text>
              </View>
              <View width="35%">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Int. Agencia:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.a3NúmeroDeReferencia || data.nroDeInterno}</Text>
                </Text>
              </View>
            </View>

            <View
            // style={{ marginTop: "5px" }}
            >
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Facturas(s):{" "}
                  </Text>
                  <Text padding="2px 3px">
                    {data.documentosSeccionLSubDatas
                      ?.filter((doc) => doc.label === "FACTURA COMERCIAL")
                      ?.map((doc) => doc.description2)
                      ?.join(", ")}
                  </Text>
                </Text>
              </View>
            </View>
            <View
              flexDirection="column"
              // style={{ marginTop: "5px" }}
              padding="0px 0px 3px 0px"
            >
              <View>
                <View width="50%">
                  <Text padding="2px 3px">
                    <Text padding="2px 3px" bold>
                      Proveedor/Emisor:{" "}
                    </Text>
                    <Text padding="2px 3px">
                      {data.documentosSeccionLSubDatas
                        ?.filter((doc) => doc.label === "FACTURA COMERCIAL")
                        ?.map((doc) => doc.description3)
                        ?.join(", ") || data.proveedor}
                    </Text>
                  </Text>
                </View>
              </View>
              <Text padding="2px 3px">
                <Text padding="2px 3px" bold>
                  Mercadería:{" "}
                </Text>
                <Text padding="2px 3px">{data.descripciónDeLaMercancía}</Text>
              </Text>

              <View>
                <View width="50%">
                  <Text padding="2px 3px">
                    <Text padding="2px 3px" bold>
                      Bultos:{" "}
                    </Text>
                    <Text padding="2px 3px">
                      {data.f3TotalNúmeroDeBultos}
                    </Text>
                  </Text>
                </View>
              </View>

              <View>
                <View width="50%">
                  <Text padding="2px 3px">
                    <Text padding="2px 3px" bold>
                      Peso:{" "}
                    </Text>
                    <Text padding="2px 3px">
                      {data.f4TotalPesoBruto}
                    </Text>
                  </Text>
                </View>
              </View>

            </View>
            <View border={{ top: true, bottom: true }} padding="3px 0px 3px 0px">
              <View width="18%" flexDirection="column">
                <Text padding="2px 3px" bold>
                  Valor FOB
                </Text>
                <Text padding="2px 3px" bold>
                  Fletes I,II
                </Text>
                <Text padding="2px 3px" bold>
                  Seguro
                </Text>
                <Text padding="2px 3px" bold>
                  Otros Gastos
                </Text>
                <Text padding="2px 3px" bold>
                  Gastos Puerto
                </Text>
                <Text padding="2px 3px" bold>
                  Otros Erogaciones
                </Text>
                <Text padding="2px 3px" bold>
                  Valor CIF
                </Text>
                <Text padding="2px 3px" bold>
                  T.c.
                </Text>
                <Text padding="2px 3px" bold>
                  Valor CIF
                </Text>
              </View>
              <View width="5%" flexDirection="column">
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px">$us.</Text>
                <Text padding="2px 3px"> {data.TipoDeCambio}</Text>
                <Text padding="2px 3px">Bs.</Text>
              </View>
              <View
                width="12%"
                flexDirection="column"
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Text padding="2px 3px">{data.f6TotalValorFob}</Text>
                <Text padding="2px 3px">{data.fleteIYIi}</Text>
                <Text padding="2px 3px">{data.f8TotalCostoDelSeguro}</Text>
                <Text padding="2px 3px">{data["f9GastosDeCarga,Descarga,ManipuleoYOtrosGastos"]}</Text>
                <Text padding="2px 3px">{data.gastosPuerto}</Text>
                <Text padding="2px 3px">{data.otrosErogaciones}</Text>
                <Text padding="2px 3px">{data.cifUsd || (data.TipoDeCambio ? (data.f10TotalValorCifAduana / data.TipoDeCambio).toFixed(2) : "0.00")}</Text>
                <Text padding="2px 3px"> </Text>
                <Text padding="2px 3px">{data.f10TotalValorCifAduana}</Text>
              </View>
              <View
                style={{ marginLeft: "5%" }}
                width="50%"
                flexDirection="column"
              >
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Aduana:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.a4AduanaDeDespacho}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Modalidad:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.a6ModalidadDelRégimen}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Items:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.f2TotalNúmeroDeItems}</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Tipo:{" "}
                  </Text>
                  <Text padding="2px 3px">DIM</Text>
                </Text>
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    DIM/DEX:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.a1NúmeroDeDeclaración}</Text>
                </Text>
                {/* <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Nro. de factura:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.nroFactura}</Text>
                </Text> */}
                <Text padding="2px 3px">
                  <Text padding="2px 3px" bold>
                    Fecha de Validación:{" "}
                  </Text>
                  <Text padding="2px 3px">{data.a2FechaDeAceptación}</Text>
                </Text>
              </View>
            </View>
            <View style={{ backgroundColor: "#dddddd" }}>
              <Text bold>COSTOS SERVICIOS ADUANEROS</Text>
            </View>
            {data.serviciosAduanerosSubDatas?.map(
              (element, idx) =>
                element.description != null &&
                element.description !== "0" && (
                  <View key={idx} justifyContent="space-between" border={{ bottom: true }} padding="4px 0px">
                    <View width="50%">
                      <Text padding="4px 5px">
                        {element.label} {element.recibo ? "*" : ""}
                      </Text>
                    </View>
                    <View width="50%" justifyContent="flex-end">
                      <Text padding="4px 5px" textAlign="end">
                        {parseFloat(element.description)}
                      </Text>
                    </View>
                  </View>
                )
            )}
            <View justifyContent="flex-end">
              <View width="10%">
                <Text padding="2px 3px" bold>
                  Sub Total:
                </Text>
              </View>
              <View width="20%" justifyContent="flex-end">
                <Text padding="2px 3px" bold textAlign="end">
                  {data.serviciosAduanerosSubDatas?.reduce(
                    (acc, el) => acc + (parseFloat(el.description) || 0),
                    0
                  )}
                </Text>
              </View>
            </View>
            <View
              flexDirection="column"
              padding="5px"
              border={{ top: true, bottom: true }}
              style={{ marginTop: "5px" }}
            >
              <View justifyContent="flex-end">
                <View width="19%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Total {isQuotation ? 'Proforma' : 'Planilla'} $us. {data.TipoDeCambio}
                  </Text>
                </View>
                <View borderContent width="20%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold textAlign="end">
                    {(data.serviciosAduanerosSubDatas?.reduce(
                    (acc, el) => acc + (parseFloat(el.description) || 0),
                    0
                  ) / data.TipoDeCambio).toFixed(2)}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="16%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Total {isQuotation ? 'Proforma' : 'Planilla'} (Bs.)
                  </Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {data.serviciosAduanerosSubDatas?.reduce(
                    (acc, el) => acc + (parseFloat(el.description) || 0),
                    0
                  )}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="25%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Gastos pagados por el importador
                  </Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {data.tributosUOtrasGastosPagadosPorElImportador}
                  </Text>
                </View>
              </View>
              <View justifyContent="flex-end">
                <View width="12%" justifyContent="flex-end">
                  <Text padding="3px 3px" bold>
                    Total Anticipos
                  </Text>
                </View>
                <View
                  border={{ right: true, left: true, bottom: true }}
                  width="20%"
                  justifyContent="flex-end"
                >
                  <Text padding="3px 3px" bold textAlign="end">
                    {data.totalAnticipos}
                  </Text>
                </View>
              </View>

              {(() => {
                const totalPlanillaBs = data.serviciosAduanerosSubDatas?.reduce(
                  (acc, el) => acc + (parseFloat(el.description) || 0),
                  0
                ) || 0;
                const gastosPagados = parseFloat(data.tributosUOtrasGastosPagadosPorElImportador ?? 0);
                const totalAnticipos = parseFloat(data.totalAnticipos ?? 0);
                const saldo = totalPlanillaBs - (gastosPagados + totalAnticipos);
                return (
                  <View justifyContent="flex-end">
                    {saldo < 0 ? (
                      <View width="19%" justifyContent="flex-end">
                        <Text padding="3px 3px" bold>
                          Saldo a favor Cliente (Bs.)
                        </Text>
                      </View>
                    ) : saldo > 0 ? (
                      <View width="20%">
                        <Text padding="3px 3px" bold>
                          Saldo a favor Agencia (Bs.)
                        </Text>
                      </View>
                    ) : (
                      <View width="9%">
                        <Text padding="3px 3px" bold>
                          Saldo (Bs.)
                        </Text>
                      </View>
                    )}
                    <View
                      border={{ right: true, left: true, bottom: true }}
                      width="20%"
                      justifyContent="flex-end"
                    >
                      <Text padding="3px 3px" bold textAlign="end">
                        {saldo}
                      </Text>
                    </View>
                  </View>
                );
              })()}
            </View>
            {data.clarifications ? (
              <Text padding="2px 3px" color="#004080" fontSize="7px" bold>
                ACLARACIONES: {data.clarifications}
              </Text>
            ) : null}
            <View>
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px" color="#004080" bold>
                  BANCO UNION S.A. (Cta. Corriente)
                </Text>
                <Text padding="2px 3px">Cuenta En Bs.: {accountNumber}</Text>
                <Text padding="2px 3px">Aciabol S.R.L</Text>
              </View>
              <View width="50%" flexDirection="column">
                <Text padding="2px 3px">
                  Elaborado por: {user.user.name} {user.user.fatherLastName}{" "}
                  {user.user.motherLastName}
                </Text>
                <Text padding="2px 3px">NIT: 375386024</Text>
                {/* <Text padding="2px 3px">SWIFT: BAUNBO22</Text> */}
              </View>
            </View>
            {
              isQuotation &&
              <Text padding="2px 3px" fontSize="7px">
                Nota.: La presente Proforma esta sujeta a Cambio dentro del plazo
                requerido por Javest SRL por variacion en el T./C.
              </Text>
            }
          </View>
          <View
            flexDirection="column"
            padding="4px 0"
            justifyContent="center"
            alignItems="center"
            style={{ backgroundColor: "#213a8f" }}
          >
            <Text padding="2px 3px" color="white">
              Dirección: Av.20 de Octubre #1915, Edificio Malaga Piso 2 Of 2B.ACIABOL Agencia despachante, La Paz, Bolivia
            </Text>
            <Text padding="2px 3px" color="white">
              Teléfono: (591)77713481
            </Text>
            <Text padding="2px 3px" color="white">
              Email: gerencia.aciabol@gmail.co
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div>
      {
        !isQuotation &&
        <div className="flex justify-end mb-2">
          <Button className="py-2" onClick={handleOnClick}>
            Guardar planilla <i className="fas fa-cloud-upload-alt"></i>
          </Button>
        </div>
      }
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
    </div>
  );
};

export default RenderSettlement;